module.exports = __webpack_public_path__ + "static/media/right-bot.ecc8ed6a.svg";